(function() {
  var assetState = window.__bduAsyncAssets = window.__bduAsyncAssets || {};

  function loadScriptOnce(key, src) {
    if (assetState[key]) return assetState[key];

    assetState[key] = new Promise(function(resolve, reject) {
      var existing = document.querySelector('script[data-bdu-asset="' + key + '"]');

      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      script.dataset.bduAsset = key;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return assetState[key];
  }

  function loadStyleOnce(key, href) {
    if (assetState[key]) return assetState[key];

    assetState[key] = new Promise(function(resolve, reject) {
      var existing = document.querySelector('link[data-bdu-asset="' + key + '"]');

      if (existing) {
        resolve();
        return;
      }

      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.bduAsset = key;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });

    return assetState[key];
  }

  function initCollectionSlider(slider) {
    if (slider.dataset.swiperInitialized === 'true' || typeof Swiper === 'undefined') return;

    slider.dataset.swiperInitialized = 'true';

    var isLogos = slider.dataset.sliderType === 'logos';
    var config = isLogos
      ? {
          slidesPerView: 3,
          spaceBetween: 16,
          breakpoints: {
            768: { slidesPerView: 5, spaceBetween: 20 },
            1024: { slidesPerView: 10, spaceBetween: 24 }
          },
          navigation: {
            nextEl: slider.parentElement.querySelector('.c-collections-slider__next'),
            prevEl: slider.parentElement.querySelector('.c-collections-slider__prev')
          }
        }
      : {
          slidesPerView: 1.2,
          spaceBetween: 12,
          breakpoints: {
            768: { slidesPerView: 3, spaceBetween: 16 },
            1024: { slidesPerView: 4, spaceBetween: 24 }
          },
          pagination: {
            el: slider.querySelector('.c-collections-slider__pagination'),
            clickable: true
          },
          navigation: {
            nextEl: slider.parentElement.querySelector('.c-collections-slider__next'),
            prevEl: slider.parentElement.querySelector('.c-collections-slider__prev')
          }
        };

    new Swiper(slider, config);

    slider.parentElement.querySelectorAll('.c-collections-slider__next, .c-collections-slider__prev').forEach(function(btn) {
      btn.addEventListener('mousedown', function(e) { e.preventDefault(); });
    });
  }

  function observeCollectionSliders() {
    var sliders = Array.from(document.querySelectorAll('.js-collections-slider'));

    if (!sliders.length) return;

    function activateSlider(slider) {
      if (typeof Swiper !== 'undefined') {
        initCollectionSlider(slider);
        return;
      }
      Promise.all([
        loadStyleOnce('swiper-css', 'https://cdn.jsdelivr.net/npm/swiper@11.0.5/swiper-bundle.min.css'),
        loadScriptOnce('swiper-js', 'https://cdn.jsdelivr.net/npm/swiper@11.0.5/swiper-bundle.min.js')
      ]).then(function() {
        initCollectionSlider(slider);
      }).catch(function() {
        slider.dataset.swiperInitialized = '';
      });
    }

    if (!('IntersectionObserver' in window)) {
      sliders.forEach(activateSlider);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        activateSlider(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '300px 0px'
    });

    sliders.forEach(function(slider) {
      observer.observe(slider);
      slider.addEventListener('pointerenter', function handlePointerEnter() {
        activateSlider(slider);
        slider.removeEventListener('pointerenter', handlePointerEnter);
      }, { once: true });
      slider.addEventListener('touchstart', function handleTouchStart() {
        activateSlider(slider);
        slider.removeEventListener('touchstart', handleTouchStart);
      }, { once: true });
    });
  }

  observeCollectionSliders();

  var $faqTop = $('.js-faq-top');
  var $pdpStickyButton = $("#desc_blk_bot--pdp");
  var $headerBot = $('.header_bot');

  if ($faqTop.length) {
    $faqTop.on('click', function() {
      $(this).parent().find('.js-faq-bottom').slideToggle();
      $(this).toggleClass('js-open');
    });
  }

  $('.c-rte-xfive iframe').wrap('<div class="c-iframe-wrapper" />');

  $('.js-spec_options_open').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.specification').find('.js-spec_options').slideToggle();
  });

  $('.js-spec_options').on('click', function(e) {
    e.preventDefault();
  });

  function runForPdpSticky(headerBotHeight) {
    var topOfElement = $pdpStickyButton.offset().top;
    var bottomOfElement = $pdpStickyButton.offset().top + $pdpStickyButton.outerHeight();
    var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight() - headerBotHeight;
    var topOfScreen = $(window).scrollTop() + headerBotHeight;

    if (bottomOfScreen > topOfElement) {
      $pdpStickyButton.css({
        height: 'auto'
      }).removeClass('fixed');
    } else if (topOfScreen < bottomOfElement) {
      $pdpStickyButton.css({
        height: $pdpStickyButton.outerHeight()
      }).addClass('fixed');
    }
  }

  if ($pdpStickyButton.length) {
    var headerBotHeight = $headerBot.length ? $headerBot.outerHeight() : 0;
    var target = document.querySelector('.desc_blk .col-sm-12');

    if (target) {
      var observer = new MutationObserver(function() {
        var dpoContainer = document.querySelector('.dpo-container');

        if (!dpoContainer) return;

        var observer2 = new MutationObserver(function() {
          $('body').addClass('dpo-loaded');
          runForPdpSticky(headerBotHeight);
        });

        observer2.observe(dpoContainer, {
          attributes: true,
          attributeFilter: ['style']
        });

        observer.disconnect();
      });

      observer.observe(target, {
        attributes: true,
        childList: true,
        characterData: true
      });
    }

    var pdpStickyTicking = false;
    var handlePdpStickyScroll = function() {
      if (pdpStickyTicking) return;
      pdpStickyTicking = true;

      requestAnimationFrame(function() {
        runForPdpSticky(headerBotHeight);
        pdpStickyTicking = false;
      });
    };

    window.addEventListener('scroll', handlePdpStickyScroll, { passive: true });
  }
})();

(function() {
  var bars = Array.from(document.querySelectorAll('.js-text-bar'));
  if (bars.length < 1) return;

  function calcTime(bar) {
    var text = bar.querySelector('.js-text');
    var speed = bar.dataset.speed;
    var width = window.innerWidth > text.offsetWidth ? window.innerWidth : text.offsetWidth;
    var duration = width / 1000 * speed;

    requestAnimationFrame(function() {
      bar.style.setProperty('--duration', duration + 's');
    });
  }

  bars.forEach(function(bar) {
    calcTime(bar);
    window.addEventListener('resize', function() {
      calcTime(bar);
    });
  });
})();

(function() {
  var inputs = Array.from(document.querySelectorAll('.js-cart-item-qty'));

  function onInputBlur(event) {
    var input = event.target;
    var lineID = input.getAttribute('data-line');
    var initialQuantity = Number(input.getAttribute('data-item-qty'));
    var qty = Number(input.value);

    qty = qty > 0 ? qty : 1;

    if (qty !== initialQuantity) {
      window.location = window.location.origin + '/cart/change?line=' + lineID + '&quantity=' + qty;
    }
  }

  inputs.forEach(function(input) {
    input.addEventListener('blur', onInputBlur);
  });
})();

(function() {
  var links = Array.from(document.querySelectorAll('.js-back-link'));

  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      window.history.back();
    });
  });
})();

(function() {
  var trimItems = Array.from(document.querySelectorAll('[js-trim-item]'));

  trimItems.forEach(function(item) {
    item.innerHTML = item.innerHTML.replaceAll('&nbsp;', '').trim();
  });
})();

(function() {
  var wrapper = document.querySelector('.js-sticky-bar-wrapper');
  var bar = document.querySelector('.js-cart-sticky-bar');

  if (!wrapper || !bar) return;

  var checkoutButton = document.querySelector('.js-sticky-bar-checkout-button');
  var header = document.querySelector('#header');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var entryAboveTopEdge = entry.boundingClientRect.top < 0;
      var op = !entry.isIntersecting && !entryAboveTopEdge ? 'add' : 'remove';
      bar.classList[op]('shown');
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 1
  });

  observer.observe(wrapper);

  if (checkoutButton && header) {
    checkoutButton.addEventListener('click', function() {
      wrapper.style = '--header-height: ' + header.clientHeight + 'px';
      wrapper.scrollIntoView({ behavior: 'smooth' });
    });
  }
})();
